<template>
  <div style="width: 100%">
    <ul class="tip text-sm text-info">
      <li>请不要重复创建字段，重复字段将修改原数据</li>
      <li>内置函数：本单位($unit) 本部门($dept) 本人($user)</li>
    </ul>
    <el-form ref="ff" v-loading="loading" :model="formdata">
      <el-form-item label="字段" required prop="Text">
        <el-input v-model="formdata.Text" />
      </el-form-item>
      <el-form-item label="值" required prop="Value">
        <el-input v-model="formdata.Value" />
      </el-form-item>
      <el-form-item>
        <el-button type="danger" @click="onSubmit">确定</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  props: {
    mode: { type: Number },
    target: { type: String },
    action: { type: String },
    callback: { type: Function },
    layerid: { type: String, default: null }
  },
  data () {
    return {
      loading: false,
      formdata: {
        Mode: this.mode,
        Target: this.target,
        Action: this.action
      }
    }
  },
  methods: {
    onSubmit () {
      this.$refs['ff'].validate(valid => {
        if (valid && !this.loading) {
          this.loading = true
          this.$apis.system.role.limit.setting(this.formdata).then(() => {
            this.callback()
            this.$layer.close(this.layerid)
          }).catch(e => {
            this.$message.error(e || "执行错误")
          }).finally(() => {
            this.loading = false
          })
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
ul.tip {
  li {
    list-style: none;
  }
}
</style>